import { render, staticRenderFns } from "./alt-product.vue?vue&type=template&id=de1e9b3c&scoped=true&"
import script from "./alt-product.vue?vue&type=script&lang=js&"
export * from "./alt-product.vue?vue&type=script&lang=js&"
import style0 from "./alt-product.vue?vue&type=style&index=0&id=de1e9b3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1e9b3c",
  null
  
)

export default component.exports